
    var riot = require('riot')
    //src: starling/src/tags/tools-sidebar.html
riot.tag2('tools-sidebar',
  '<section ref="tabs" class="side-tabs"> <creation-tools-tab show="{isTabActive(\'creation-tools-tab\')}" canvas="{canvas}"></creation-tools-tab> <perspectives-listing if="{canvas.isFeatureEnabled(\'perspectives\')}" show="{isTabActive(\'perspectives-listing\')}" canvas="{canvas}"></perspectives-listing> <attributes-tab if="{canvas.isFeatureEnabled(\'attributes\')}" show="{isTabActive(\'attributes-tab\')}" canvas="{canvas}"></attributes-tab> <waypoints-tab if="{canvas.isFeatureEnabled(\'presentation\')}" show="{isTabActive(\'waypoints-tab\')}" canvas="{canvas}"></waypoints-tab> </section> <div ref="tools" class="tools-sidebar_tools {view-only: canvas.isViewOnly()}"> <div class="creation-tools_container"> <creation-tools hide="{canvas.isViewOnly()}" canvas="{canvas}"></creation-tools> <div if="{canvas.isFeatureEnabled(\'perspectives\') ||           canvas.isFeatureEnabled(\'attributes\') ||           canvas.isFeatureEnabled(\'presentation\')}" class="creation-tools"> <ul class="creation-tools_list {view-only: canvas.isViewOnly()}"> <li if="{canvas.isFeatureEnabled(\'perspectives\')}" class="creation-tools_list_item tip-container" onclick="{activateTab.bind(this, {               tabTagName: \'perspectives-listing\',               push: true,             })}"> <button class="Button Button--Icon Button--Small Button--Plain {Button--Active: isTabActive(\'perspectives-listing\')}"> <svg class="Button__Icon"> <use xlink:href="#visibility-icon"></use> </svg> </button> <tip class="creation-tool_tip tip-align-true-right"> <h3 class="creation-tool_tip_title">Perspectives</h3> <p class="creation-tool_tip_description">Filter and describe cards from unique points-of-view</p> </tip> </li> <li if="{canvas.isFeatureEnabled(\'attributes\')}" class="creation-tools_list_item tip-container" onclick="{activateTab.bind(this, {               tabTagName: \'attributes-tab\',               push: true,             })}"> <button class="Button Button--Icon Button--Small Button--Plain {Button--Active: isTabActive(\'attributes-tab\')}"> <svg class="Button__Icon"> <use xlink:href="#tags-icon"></use> </svg> </button> <tip class="creation-tool_tip tip-align-true-right"> <h3 class="creation-tool_tip_title">Tags</h3> <p class="creation-tool_tip_description">Categorize and filter cards in this map by metadata</p> </tip> </li> <li if="{canvas.isFeatureEnabled(\'presentation\')}" class="creation-tools_list_item tip-container" onclick="{activateTab.bind(this, {               tabTagName: \'waypoints-tab\',               push: true,             })}"> <button class="Button Button--Icon Button--Small Button--Plain {Button--Active: isTabActive(\'waypoints-tab\')}"> <svg class="Button__Icon"> <use xlink:href="#airplay-icon"></use> </svg> </button> <tip class="creation-tool_tip tip-align-true-right"> <h3 class="creation-tool_tip_title">Slides</h3> <p class="creation-tool_tip_description">Present your ideas in a walk-through of your map</p> </tip> </li> </ul> </div> </div> </div>',
  '',
  'hide="{pageSettings.hideMapToolsSidebar}" class=" tools-sidebar {isOpen ? \'\' : \'tools-sidebar--collapsed\'} {pageSettings.hideMapHeader ? \'tools-sidebar--top\' : \'\'} " onmouseenter="{handleMouseEnter}" onmouseleave="{handleMouseLeave}"', function(opts) {
'use strict';

var _this = this;

var _perspectivesUi = require('lib/perspectives-ui');

var _nodesUi = require('lib/nodes-ui');

var _upsellUi = require('lib/upsell-ui');

var _creationToolsUi = require('lib/creation-tools-ui');

var _relationshipUi = require('lib/relationship-ui');

var _store_instance = require('../store_instance');

var _store_instance2 = _interopRequireDefault(_store_instance);

var _componentTemplates = require('lib/component-templates');

var _componentTemplates2 = _interopRequireDefault(_componentTemplates);

var _copyPaste = require('lib/copy-paste');

var _copyPaste2 = _interopRequireDefault(_copyPaste);

var _eventTracking = require('lib/event-tracking');

var _eventTracking2 = _interopRequireDefault(_eventTracking);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// const storedOpenState = localStorage.getItem('tools-sidebar');
// this.isOpen = storedOpenState ? storedOpenState === 'true' : true;
this.isOpen = false;

this.store = _store_instance2.default;
this.canvas = this.opts.canvas;
this.canvas.toolsSidebarTag = this;
this.operation = this.opts.operation;

this.activeTabs = [];

this.handleDragStart = function (e) {
  if (_this.canvas.isViewOnly()) {
    return;
  }
  if (_this.canvas.isSafari) {
    return;
  } // disable drag-drop creation for Safari
  _this.creationToolsList.classList.add('creation-tools_list--hide-tips');
  var componentId = e.target.getAttribute('data-component-id');
  _this.canvas.dragState.draggingComponentId = componentId;
  _this.creationToolsTab.classList.add('hide-tips');
  var ghostEl = e.target.querySelector('.icon');
  _this.ghostEl = ghostEl;
  ghostEl.style = 'pointer-events: none';
  e.dataTransfer.setDragImage(ghostEl, 0, 0);
  e.dataTransfer.setData('text/plain', 'component');
  _creationToolsUi.ctui.setActiveTool(componentId);
};

this.handleDragEnd = function (e) {
  if (_this.canvas.isViewOnly()) {
    return;
  }
  if (_this.canvas.isSafari) {
    return;
  }
  if (_this.ghostEl) {
    _this.ghostEl.style = '';
  }
  _this.creationToolsList.classList.add('creation-tools_list--hide-tips');
  _this.creationToolsTab.classList.add('hide-tips');
  var mouseX = e.clientX || _this.canvas.mouseX;
  var mouseY = e.clientY || _this.canvas.mouseY;
  _this.canvas.hidePopups();
  _this.canvas.clearSelectedElements();
  var componentId = e.target.getAttribute('data-component-id');

  var sidebarWidth = _this.isOpen ? 314 : 54;

  if (mouseX < sidebarWidth) return;

  _eventTracking2.default.track({
    category: 'Tools-Sidebar',
    action: 'Drag-Create-' + _this.capitalize(componentId),
    label: 'Creation-Tools'
  });

  if (componentId === 'relationship-tool') {
    if (_this.canvas.dragEnteredNode) {
      _relationshipUi.rui.startCreationFromCard(e, _this.canvas.dragEnteredNode);
    } else {
      _relationshipUi.rui.createNewLineOnCanvas({ e: e, x: e.clientX, y: e.clientY });
    }
    _relationshipUi.rui.clickCount++;
    return;
  }

  if (_upsellUi.usui.userIsOverLimit()) {
    _this.canvas.showPaymentModal();
    return;
  }

  var data = _componentTemplates2.default[componentId];

  var _canvas$getMatrix = _this.canvas.getMatrix(),
      scale = _canvas$getMatrix.scale,
      tx = _canvas$getMatrix.tx,
      ty = _canvas$getMatrix.ty;

  var position = {
    x: mouseX,
    y: mouseY
  };

  var _CopyPaste$pasteData = _copyPaste2.default.pasteData({
    data: data,
    canvas: _this.canvas,
    forcedNewParent: _this.canvas.dragEnteredNode,
    position: position,
    forcePastePerspectives: true
  }),
      nodeOldtoNewIds = _CopyPaste$pasteData.nodeOldtoNewIds;

  if (Object.keys(nodeOldtoNewIds).length && !_this.canvas.dragEnteredNode) {
    //if we're not dragging a region and not adopting
    var topNode = _store_instance2.default.getNode(Object.values(nodeOldtoNewIds)[0]).getTopLevelParent();
    var topNodeTag = _this.canvas.nodeTags[topNode.id];
    topNodeTag.focusTitle();
  }
  if (componentId === 'image') {
    var node = _store_instance2.default.getNode(Object.values(nodeOldtoNewIds)[0]);
    canvas.imageModal.show(node.id);
  }

  _this.canvas.setDragEnteredNode(null);
  _this.canvas.appFooterTag.updateStyle();
};

this.handleClick = function (e) {

  var target = $(e.target).closest('.creation-tools_list_item').get(0) || $(e.target).closest('.creation-tools_tool').get(0);
  if (!target) return;
  e.stopPropagation();

  var componentId = target.getAttribute('data-component-id');

  var toolName = _this.canvas.activeToolName === componentId ? 'pointer' : componentId;

  _creationToolsUi.ctui.setActiveTool(toolName);

  _this.canvas.creationToolsTag.update();

  /*
  if (this.canvas.isViewOnly()) { return; }
  this.canvas.hidePopups();
  this.canvas.clearSelectedElements();
   this.creationToolsList.classList.add('creation-tools_list--hide-tips');
  this.creationToolsTab.classList.add('hide-tips');
   EventTracker.track({
    category: 'Tools-Sidebar',
    action: `Click-Create-${this.capitalize(componentId)}`,
    label: 'Creation-Tools',
  });
   if (componentId === 'relationship-tool') {
    rui.createNewLineOnCanvas({x: e.clientX, y: e.clientY});
    return;
  }
   if (usui.userIsOverLimit()) {
    this.canvas.showPaymentModal();
    return;
  }
   const data = templates[componentId];
  const { scale, tx, ty } = this.canvas.getMatrix();
  const position = {
    x: (this.isOpen ? 350 : 100),
    y: e.clientY
  };
   const { nodeOldtoNewIds } = CopyPaste.pasteData({
    data,
    canvas: this.canvas,
    position,
    forcePastePerspectives: true,
  });
   if (Object.keys(nodeOldtoNewIds).length && !this.canvas.dragEnteredNode) {
    //if we're not dragging a region and not adopting
    const topNode = store.getNode(Object.values(nodeOldtoNewIds)[0]).getTopLevelParent();
    const topNodeTag = this.canvas.nodeTags[topNode.id];
    topNodeTag.focusTitle();
  }
  this.canvas.appFooterTag.updateStyle();
  */
};

this.restoreTips = function (e) {
  _this.creationToolsList.classList.remove('creation-tools_list--hide-tips');
  _this.creationToolsTab.classList.remove('hide-tips');
};

this.on('mount', function () {
  _this.creationToolsTag = _this.tags['creation-tools'] || _this.tags['creation-tools-grouped'];
  _this.creationToolsTab = _this.tags['creation-tools-tab'].root;
  _this.creationTools = _this.creationToolsTag.refs.creationTools;
  _this.creationToolsList = _this.creationToolsTag.refs.creationToolsList;

  _this.canvas.attachRightClickDismissEvent(_this.root);
});

this.loadVideos = function () {
  if (_this.loadedVideos) return;
  for (var _iterator = _this.root.querySelectorAll('video'), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var el = _ref;

    if (el.hasAttribute('data-src')) {
      el.setAttribute('src', el.getAttribute('data-src'));
    }
  }
  _this.loadedVideos = true;
};

this.handleMouseEnter = function (e) {
  _this.loadVideos();
  _this.canvas.disablePanZoom();
};

this.handleMouseLeave = function (e) {
  _this.canvas.enablePanZoom();
  _this.restoreTips();
};

this.toggleShowAllPerspectives = function () {
  _perspectivesUi.pui.toggleShowAllPerspectives();
};

this.isTabActive = function (tabTagName) {
  return _this.activeTabs.includes(tabTagName);
};

this.openSidebar = function (_ref2) {
  var activeTabs = _ref2.activeTabs;

  _this.isOpen = true;
  _this.activeTabs = activeTabs;
  localStorage.setItem('tools-sidebar', _this.isOpen);
  _this.canvas.perspectiveBannerTag.setHidden(_this.isTabActive('perspectives-listing'));
  _this.update();
};

this.closeSidebar = function () {
  _this.isOpen = false;
  _this.activeTabs = [];
  localStorage.setItem('tools-sidebar', _this.isOpen);
  _this.canvas.perspectiveBannerTag.setHidden(false);
  _this.update();
};

this.capitalize = function () {
  var words = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return words.split('-').map(function (word) {
    return word.length ? '' + word[0].toUpperCase() + word.slice(1) : '';
  }).join('-');
};

this.trackTabEvent = function (tabTagName, action) {
  var name = _this.capitalize(tabTagName);

  _eventTracking2.default.track({
    category: 'Tools-Sidebar',
    action: action + '-' + name,
    label: name.split('-').slice(0, -1).join('-')
  });
};

this.activateTab = function (_ref3) {
  var tabTagName = _ref3.tabTagName,
      _ref3$push = _ref3.push,
      push = _ref3$push === undefined ? false : _ref3$push;
  var activeTabs = _this.activeTabs;

  _this.trackTabEvent(tabTagName, _this.isTabActive(tabTagName) ? 'Close' : 'Open');

  if (_this.isTabActive(tabTagName)) {
    activeTabs = activeTabs.filter(function (tab) {
      return tab !== tabTagName;
    });
  } else if (push) {
    activeTabs.push(tabTagName);

    if (activeTabs.includes('creation-tools-tab')) {
      activeTabs.splice(activeTabs.indexOf('creation-tools-tab'), 1);
    }
  } else {
    activeTabs = [tabTagName];
  }

  if (activeTabs.length) {
    _this.openSidebar({ activeTabs: activeTabs });
  } else {
    _this.closeSidebar();
  }
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('tools-sidebar')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/tools-sidebar.html
// module id = 641
// module chunks = 0